<template>
<div class="col-12 mt-4 mb-0 border-box p-0">
    <div class="row">
        <div class="col-2 pl-4 border-right" v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice">
            <RegisterStep @saveChange="handleSaveChange"/>
        </div>
        <div class="col-2 pl-4 border-right" v-else>
            <CompanyRegisterStep />
        </div>
        <div class="col-10">
            <div class="row d-flex justify-content-center align-items-start h-100">
                <div class="col-10 h-100">
                    <div class="row d-flex justify-content-start align-items-start py-3">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row px-0 mx-0">
        <slot name="footer"></slot>
    </div>
</div>
</template>

<script>
import RegisterStep from '@/components/navigation/steps/RegisterStep'
import CompanyRegisterStep from '@/components/navigation/steps/CompanyRegisterStep'
export default {
    components: {
        RegisterStep,
        CompanyRegisterStep
    },
    methods: {
        handleSaveChange() {
            this.$emit('saveChange')
        },
    },
};
</script>

<style lang="scss" scoped>
</style>